export const tradeViewBaseSymbol = 'usdt';
